import React,{useState, useEffect} from 'react';

const EventCalendar = () => {
  return (
    <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">Calendar Event</h5>
                            <span className='p-2'></span>
                            <div>
                            <span className='p-2'></span>
                            <button className='btn btn-success'>
                                Add Event +
                            </button>
                            </div>
                        </div>
                        <div className='card-body'>
                            <h1>Event-Calendar</h1>
                        </div>
                    </div>
                </div>
            </div>          
        </>
  )
}

export default EventCalendar
